import { render, staticRenderFns } from "./ClientBloodPressure.vue?vue&type=template&id=757aca1c&scoped=true"
import script from "./ClientBloodPressure.vue?vue&type=script&lang=js"
export * from "./ClientBloodPressure.vue?vue&type=script&lang=js"
import style0 from "./ClientBloodPressure.vue?vue&type=style&index=0&id=757aca1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757aca1c",
  null
  
)

export default component.exports